import {
  addToCart,
  type Cart,
  type CartItemInput,
  createCart,
  getCart,
  updateCartLines,
} from './storefrontClient';

export async function addOrUpdateCartItem(
  cartId: string | null,
  item: CartItemInput
): Promise<{ cart: Cart; cartId: string }> {
  let cart: Cart;

  if (!cartId) {
    cart = await createCart([item]);
    return { cart, cartId: cart.id };
  }

  try {
    cart = await getCart(cartId);

    if (isStaleCart(cart.updatedAt)) {
      cart = await createCart([item]);
      return { cart, cartId: cart.id };
    }
  } catch {
    cart = await createCart([item]);
    return { cart, cartId: cart.id };
  }

  const existingLine = cart.lines.edges.find(
    (line) => line.node.merchandise.id === item.merchandiseId
  );

  if (existingLine) {
    const updatedQuantity = existingLine.node.quantity + item.quantity;
    cart = await updateCartLines(cartId, [
      { id: existingLine.node.id, quantity: updatedQuantity },
    ]);
  } else {
    cart = await addToCart(cartId, [item]);
  }

  return { cart, cartId };
}

export function quickCheckout(variantGid: string, quantity: number): void {
  const variantId = variantGid?.split('/').pop() || '';
  window.location.href = `https://shop.sunrun.com/cart/${variantId}:${quantity}`;
}

export const isStaleCart = (updatedAt: string): boolean => {
  const ONE_DAY_IN_MS = 1000 * 60 * 60 * 24;

  const updateTime = new Date(updatedAt).getTime();
  const currentTime = Date.now();

  const ageMs = currentTime - updateTime;
  return ageMs >= ONE_DAY_IN_MS;
};
